(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    module.factory('TextMessageService', ['$http','SharedAgendaService', TextMessageServiceFn]);
    function TextMessageServiceFn($http, SharedAgendaService) {
        var baseUrl = '/api/textmessages';

        var service = {
            send: send
        };

        return service;

        /* send text message */
        function send(phoneNumber, content) {
            return $http({
                url: baseUrl + '/' + SharedAgendaService.currentUser().id,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                data: $.param({
                    phoneNumber: phoneNumber,
                    content: content
                })
            }).then(function (response) { return response.data; });
        }
    }
})();